import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AppRoute, AuthRoute, CreatePasswordRouteGuard, OnBoardRouteGuard, PermissionDashboardRoute, PermissionRoute, UpdateCompanyRouteGuard } from './ProtectedRoutes';
import { useDispatch, useSelector } from 'react-redux';
import { initCompanyDetails, initTraderDetails, login, refreshUserData } from '../redux/features/authSlice';
import { CircularProgress, Backdrop, Stack } from '@mui/material';
import appapi from '../api/apiClient';
import Privacy from '../pages/Legal/Privacy';
import Terms from '../pages/Legal/Terms';
import Analytics from '../pages/Layouts/Analytics/Analytics';
import UserManagement from '../pages/Layouts/UserManagement/UserManagement';
import Login from '../pages/Auth/login/Login';
import ResetConfirm from '../pages/Auth/resetConfirmPassword/ResetConfirm';
import jwt_decode from 'jwt-decode';
import ForgotPassword from '../pages/Auth/resetPassword/ForgotPassword';
import CreateNewPassword from './../pages/Layouts/PasswordReset/CreateNewPassword';
import LoadingIndicator from '../components/LoadingIndicator';
import OnBoardCompany from '../pages/Layouts/OnBoardCompany';
import ContactManagement from '../pages/Layouts/ContactManagement/ContactManagement';
import Settings from '../pages/Layouts/Settings/Settings';
import FleetManagement from '../pages/Layouts/FleetManagement/FleetManagement';
import TradeManagement from '../pages/Layouts/TradeManagement/TradeManagement';
import { initCountryList, initFuelList, initGraphData, initNotifyCount, initShipCharterers, initShipManagers, initShipOperators, initShipOwners, initShipTypesList, initTransactionData, initverifiers } from '../redux/features/layoutSlice';
import { CancelToken } from 'apisauce';
import Layout from '../pages/Layouts/Layout';
import Dashboard from '../pages/Layouts/Dashboard/Dashboard';
import TraderClientManagement from '../pages/Layouts/TraderClientManagement/TraderClientManagement';
import TradeManagementMain from '../pages/Layouts/TraderManagementMain/TradeManagementMain';
import NotFound from '../pages/NotFound/NotFound';
import PortfolioManagement from '../pages/Layouts/PortfolioManagement/PortfolioManagement';

export default function RootNavigation() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  let source = CancelToken.source();

  const { userId, user } = useSelector((state) => state.auth);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      const decoded = jwt_decode(accessToken);
      dispatch(login(decoded.sub));
      if (userId) {
        getuserdetails(decoded.sub);
      }
    } else {
      setLoading(false);
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [userId]);

  const getuserdetails = async (userId) => {
    if (userId) {
      source.cancel();
      source = CancelToken.source();
      const response = await appapi.get(`/user/details`, {}, { cancelToken: source.token });
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(refreshUserData(data.response));
          setTimeout(() => {

            if(data.response.type === 'trader') {
              dispatch(initTraderDetails());
            } else {
              dispatch(initCompanyDetails());
            }
            dispatch(initCountryList());
            dispatch(initFuelList());
            dispatch(initShipTypesList());
            dispatch(initShipOwners());
            dispatch(initShipManagers());
            dispatch(initShipCharterers());
            dispatch(initShipOperators());
            dispatch(initverifiers());
            dispatch(initGraphData());
            dispatch(initNotifyCount());
            dispatch(initTransactionData())
          }, 200);
        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
  };

  return loading ? (
    <Stack
      sx={{ height: '100vh' }}
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Stack>
  ) : (
    <>
      <Routes>
        <Route
          path="/privacy"
          element={<Privacy />}
        />
        <Route
          path="/login"
          element={
            <AppRoute>
              <Login />
            </AppRoute>
          }
        />
        <Route
          path="/forgotPassword"
          element={
            <AppRoute>
              <ForgotPassword />
            </AppRoute>
          }
        />
        <Route
          path="/resetPassword/:verificationToken"
          element={
            <AppRoute>
              <ResetConfirm />
            </AppRoute>
          }
        />

        <Route
          path="/createNewPassword"
          element={
            <AuthRoute>
              <CreatePasswordRouteGuard>
                <CreateNewPassword />
              </CreatePasswordRouteGuard>
            </AuthRoute>
          }
        />
        <Route
          path="/updateCompanyProfile"
          element={
            <AuthRoute>
              <UpdateCompanyRouteGuard>
                <OnBoardCompany />
              </UpdateCompanyRouteGuard>
            </AuthRoute>
          }
        />

        <Route
          path="/"
          element={
            <AuthRoute>
              <OnBoardRouteGuard>
                <Layout />
              </OnBoardRouteGuard>
            </AuthRoute>
          }
        >
          <Route
            path=""
            element={
              <PermissionDashboardRoute name="Dashboard">
                <Dashboard />
              </PermissionDashboardRoute>
            }
          />
          <Route
            path="userManagement"
            element={
              <PermissionRoute name="UserManagement">
                <UserManagement />
              </PermissionRoute>
            }
          />
          <Route
            path="contactManagement"
            element={
              <PermissionRoute name="ContactManagement">
                <ContactManagement />
              </PermissionRoute>
            }
          />
          <Route
            path="settings"
            element={
              <PermissionRoute name="Settings">
                <Settings />
              </PermissionRoute>
            }
          />
          <Route
            path="fleetManagement"
            element={
              <PermissionRoute name="fleetManagement">
                <FleetManagement />
              </PermissionRoute>
            }
          />
          <Route
            path="tradeManagement"
            element={
              <PermissionRoute name="tradeManagement">
               {user?.type === 'trader' ? <TradeManagementMain /> : <TradeManagement />}
              </PermissionRoute>
            }
          />
          <Route
            path="clientManagement"
            element={
              <PermissionRoute name="TraderClientManagement">
                <TraderClientManagement />
              </PermissionRoute>
            }
          />
          <Route
            path="portfolioManagement"
            element={
              <PermissionRoute name="PortfolioManagement">
                <PortfolioManagement />
              </PermissionRoute>
            }
          />
        </Route>

        <Route
          path="/terms"
          element={<Terms />}
        />
        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
      
      <LoadingIndicator />
    </>
  );
}
